import { createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";

const LoginContext = createContext();

export const LoginProvider = ({ children }) => {
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useDispatch();
  return (
    <LoginContext.Provider value={{ buttonLoading, setButtonLoading, dispatch }}>
      {children}
    </LoginContext.Provider>
  );
};

export const useLoginContext = () => {
  return useContext(LoginContext);
};
